import * as React from "react";
import "./CTSAReportHeader.css";
import { sumComparisonGroup } from "./CTSAReportHelper";

interface Props {
    compareGroup?: string[];
    awardTotal?: {};
    displayId?: string;
    CTSASchoolList?: { display_id?: string, hub_name?: string }[];
}

const CTSAReportHeader = (props: Props) => {
    const { displayId, CTSASchoolList, awardTotal, compareGroup } = props;
    const hub = CTSASchoolList.filter(uni => uni.display_id == displayId)[0].hub_name;
    return (
        <div>
            <div className="ctsa-title-container">
                <img src={require('./special_logo.png')} className='special-logo' />
                <img
                    className="ctsa-logo-left"
                    height='50px'
                    src={'/dist/univ_logos/IRISLogoS.jpg'}
                    alt='Logo' />
  
                {
                    displayId != '-1' ?
                        <div className="ctsa-title">
                            <p>KL2 Impact Report 2024</p>
                            <p>{hub}</p>
                        </div>
                        : <div className="agg-ctsa-title">
                            <p>Aggregate KL2 Impact Report 2021</p>
                            <p className="agg-subheader">for 9 CTSA hubs: Boston University, Ohio State University, Pennsylvania State University, University of Kansas, University of Michigan, Northwestern University, University of Pittsburgh, University of Wisconsin, and Washington University in St. Louis.</p>

                        </div>


                }
                {
                    displayId != '-1' && <img
                        className="ctsa-logo-right"
                        height='65px'
                        src={`/dist/univ_logos/${displayId}.png`}
                        alt='Logo' />
                }

            </div>
            <p className="ctsa-header-paragraph">
                This report presents professional and scientific outcomes for {awardTotal ? awardTotal['KL2'] : <i className="fa fa-spinner"></i>} KL2 scholars and {awardTotal ? sumComparisonGroup(awardTotal, compareGroup) : <i className="fa fa-spinner"></i>} scholars in the selected comparison group. See the methodology tab for details about our approach.
            </p>
        </div>

    )

}

export default CTSAReportHeader;

